import React from "react";
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class ExcelExport extends React.Component {
  render() {
    const data = this.props.emailList.map((email) => ({ email: "email", emailAdress: email }));
    return (
      <ExcelFile hideElement={true}>
        <ExcelSheet data={data} name="Emails">
          <ExcelColumn label="Email List" value="emailAdress" />
        </ExcelSheet>
      </ExcelFile>
    );
  }
}
